// extracted by mini-css-extract-plugin
export var askAiIcon = "_nq-9";
export var container = "_nq-0";
export var groupSeparator = "_nq-a";
export var highlight = "_nq-4";
export var resultIcon = "_nq-5";
export var resultItem = "_nq-7";
export var resultSubtitle = "_nq-3";
export var resultTitle = "_nq-2";
export var resultsList = "_nq-1";
export var searchGroup = "_nq-6";
export var selected = "_nq-8";